import { render, staticRenderFns } from "./HomeThree.vue?vue&type=template&id=54bd2f30&"
import script from "./HomeThree.vue?vue&type=script&lang=js&"
export * from "./HomeThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports